import { AthenaTabs } from './constants';

export const getTabInfo = (integrations = []) => {
  const activeIntegrations = [];
  const inactiveIntegrations = [];

  integrations.forEach((integration) => {
    if (integration.deletedAt) {
      inactiveIntegrations.push(integration);
      return;
    }

    activeIntegrations.push(integration);
  });

  const tabInfo = {
    ACTIVE: {
      text: AthenaTabs.ACTIVE.text,
      count: activeIntegrations.length,
    },
    NOT_ACTIVE: {
      text: AthenaTabs.NOT_ACTIVE.text,
      count: inactiveIntegrations.length,
    },
    ALL: {
      text: AthenaTabs.ALL.text,
      count: integrations.length,
    },
  };

  return {
    tabInfo,
    activeIntegrations,
    inactiveIntegrations,
    allIntegrations: integrations,
  };
};
